import React from 'react';
import { Box, Typography } from '@mui/material';

interface PageHeaderProps {
  icon: React.ReactNode;
  title: string;
  /** @deprecated Subtitles removed — parameter kept for backward compat but not rendered */
  subtitle?: string;
  gradient?: string;
  rightContent?: React.ReactNode;
  mb?: number;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  icon,
  title,
  gradient = '#00E0FF, #00E676',
  rightContent,
  mb = 1.5,
}) => (
  <Box sx={{ mb, mt: 0.5, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
    <Box className="icon-text-row" sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
      <Box sx={{
        display: 'flex', alignItems: 'center', flexShrink: 0,
        '& .MuiSvgIcon-root': {
          fontSize: { xs: 22, sm: 26 },
          color: '#00E0FF',
          filter: 'drop-shadow(0 0 6px rgba(0,224,255,0.4))',
        },
      }}>
        {icon}
      </Box>
      <Typography
        sx={{
          fontFamily: 'var(--font-mono)',
          fontSize: { xs: '1rem', sm: '1.25rem' },
          fontWeight: 700,
          lineHeight: 1.2,
          textTransform: 'uppercase',
          letterSpacing: 1.5,
          background: `linear-gradient(135deg, ${gradient})`,
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          whiteSpace: 'nowrap',
        }}
      >
        {title}
      </Typography>
    </Box>
    {rightContent && <Box sx={{ ml: 1, flexShrink: 0 }}>{rightContent}</Box>}
  </Box>
);

export default PageHeader;
